// GUI:
import { memo, useEffect } from 'react';
import { Typography } from '@mui/material';
import { Panels } from '@gui/constants/Panels';
import { getGrid } from 'store/LoadingStore';

// Sections:
import usePersistentStore, { useLayersBucket } from '@gui/store/persistent/persistentStore';
// import DemandPeaksSection from './components/DemandPeaksSection';
import SolarParametersSection from './components/SolarParametersSection';
import type { DeepPartial, SolarEnergyResourcesState } from '@visualizer/types';

type SolarEnergyResourcesProps = {
    showContent: boolean;
};

const SolarEnergyResources: React.FC<SolarEnergyResourcesProps> = ({ showContent }) => {
    // Zustand Actions:
    const activeLayerId = useLayersBucket((s) => s.activeLayerID);

    const setPanel = usePersistentStore((s) => s.setPanel);
    const setSolarEnergyPanel = (updates: DeepPartial<SolarEnergyResourcesState>) => setPanel(updates, Panels.SOLAR_ENERGY_RESOURCES);

    useEffect(() => {
        const layer = getGrid().getActiveLayer();

        if (!layer || !layer.getResult()) return;
        if (!layer.isSun()) return;

        // TODO: Check that this works once the time/energy switch has been implemented:
        const energyIndex = layer.results.findIndex((r) => r.resultLabel === 'Energy');

        if (energyIndex !== -1) {
            // Point to new Result item with correct resultId, label and unit of measure:
            layer.status.data.ACTIVE_RESULT_ID = energyIndex;
            setSolarEnergyPanel({
                solarParams: {
                    unitOfMeasure: energyIndex,
                },
            });
        }

        // console.log(layer.results);
        // console.log(energyIndex);
        // console.log(layer.status.data.ACTIVE_RESULT_ID);
        // console.log(layer.getResult());
    }, [activeLayerId]);

    // Render only for Solar Layers:
    const currentLayer = getGrid().getActiveLayer();
    const isSolarLayer = currentLayer.isSun();

    if (!showContent) return null;

    return (
        <>
            {isSolarLayer ? (
                <>
                    <SolarParametersSection />
                    {/* <DemandPeaksSection /> */}
                </>
            ) : (
                <Typography color="text.secondary">
                    {currentLayer
                        ? 'Solar energy settings are available only for solar simulations. Select a solar layer in the Data panel to access these controls.'
                        : 'Select a layer in the Data panel to access solar energy settings.'}
                </Typography>
            )}
        </>
    );
};

export default memo(SolarEnergyResources);
